import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import CreateFormHeader from '../../components/form/CreateFormHeader/CreateFormHeader';
import LocationGroupCreateForm from '../../components/form/LocationGroupCreateForm';
import { Page } from '../../components/TitlePath/TitlePath';
import { useStore } from '../../stores/store';
import { TableHistory } from '../../models/Inventory';

export default function LocationGroupCreatePage() {
    const { id } = useParams();
    const { locationGroupStore } = useStore();
    const { getLocationGroupHistory } = locationGroupStore;
    const [history, setHistory] = useState<TableHistory | undefined>(undefined);

    useEffect(() => {
        const fetchHistory = async () => {
            if (id) {
                const data = await getLocationGroupHistory(id);
                setHistory(data);
            }
        };
        fetchHistory();
    }, [id, getLocationGroupHistory]);

    const lastPages: Page[] = [
        { title: "Project Management", path: "/projectManagementMenu" },
        { title: "Location Group Record", path: "/locationGroup" }
    ];

    return (
        <div className="pageParentDiv flex flex-col px-5">
            <CreateFormHeader
                registeredBy={history?.registeredBy}
                registeredOn={history?.registeredOn}
                updateBy={history?.updateBy}
                updateOn={history?.updateOn}
                lastPages={lastPages}
                titleText={id ? "Edit Location Group Record" : "Create Location Group Record"}
                formType="Location Group record"
            />
            <LocationGroupCreateForm selectedId={id} />
        </div>
    );
}

